<!--
    @created by Zheko Hristov on 19/09/2025
    @last-updated by Zheko Hristov on 19/09/2024
    This component represents the change owner section

    - this component can be used inside another vue component or standalone in page
    - if the component is used standalone in page the v-if="notedata.permissions.change_owner && noteType !== 'note'" check 
    will not work and has to be made with rails code
-->

<template>
    <div class="task-change-owner__container--outer">
        <button
            v-on:click="toggleChangeOwnerForm"
            title="Click to change owner"
            class="button--change-owner"> 
            <i class="flaticon-edit"></i> 
        </button>
        <!-- Change owner modal -->
        <div
            v-if="showChangeOwnerForm" 
            class="change-owner__container--modal show"> 
            <div class="change-owner__container--inner js-modal-container-inner">
                <div class="change-owner__container--top js-modal-container-inner-top">
                    <h3>
                        Change owner
                    </h3>
                    <button 
                        class="single-note__button--sourcing-task" 
                        v-on:click="toggleChangeOwnerForm">
                        <i class="flaticon-close"></i>
                    </button>
                </div>
                <div class="change-owner__container--middle js-modal-container-inner-middle"> 
                    <form-field
                        title="Owner"
                        fieldtype="form-dropdown"
                        inputname="owner_id"
                        v-bind:startvalue="owner"
                        searchurl="/autocomplete/staff"
                        preload='1'
                        v-bind:isdisabled="false"
                        v-on:event-bubble="setOwner"
                    ></form-field>
                    <p 
                        v-for="error in changeOwnerErrors" 
                        v-bind:key="error" 
                        class="text--error-message">
                        {{ error }}
                    </p>
                </div>
                <div class="change-owner__container--bottom js-modal-container-inner-bottom"> 
                    <div class="change-owner__container--buttons">
                        <button class="single-note__button--save" v-on:click="submitChangeOwnerForm">Submit</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormField from '../../form-field/form-field.vue';
    import Ajax from '../../form-field/sub-components/js/ajax.js';

    export default {
        props: [
            'noteid',
            'owner'
        ],
        data: function () {
            return {
                showChangeOwnerForm: false,
                changeOwnerErrors: [],
                ownerId: this.owner.id
            }
        },
        created: function () {
            
        },
        mounted: function () {
            window.addEventListener('resize', () => {
                this.calculateChangeOwnerMiddleSectionMaxHeight();
            });
        },
        updated: function () {
            this.calculateChangeOwnerMiddleSectionMaxHeight();
        },
        methods: {
            toggleChangeOwnerForm: function () {
                this.showChangeOwnerForm = !this.showChangeOwnerForm;
                
                if (!this.showChangeOwnerForm) {
                    // fixes for job request sourcing page
                    $('.sub-header__container--wrapper, #job-request-filter-form, .filter-start-with.js-filter-relocate, .table__pagination--wrapper')
                        .css({ 'pointer-events': 'auto', 'opacity': '1' });
                } else {
                    // fixes for job request sourcing page
                    $('.sub-header__container--wrapper, #job-request-filter-form, .filter-start-with.js-filter-relocate, .table__pagination--wrapper')
                        .css({ 'pointer-events': 'none', 'opacity': '0' });
                }
            },
            setOwner: function (event) {
                this.ownerId = event.data.id;
            },
            submitChangeOwnerForm: function () {
                const Data = {};
                
                Data.owner_id = this.ownerId;

                Ajax.request(
                    'POST',
                    Data,
                    `/notes/${this.noteid}/change-owner`,
                    (response) => {
                        window.location.reload();
                    },
                    this,
                    (response) => {
                        const responseObject = JSON.parse(response);
                        this.changeOwnerErrors = responseObject.errors;
                    }
                );
            },
            calculateMaxHeightFunction: function (modalContainerOuter) {
                const modalContainerInner = modalContainerOuter.querySelector('.js-modal-container-inner');
                const modalContainerTop = modalContainerOuter.querySelector('.js-modal-container-inner-top');
                const modalContainerBottom = modalContainerOuter.querySelector('.js-modal-container-inner-bottom');
                const modalContainerMiddle = modalContainerOuter.querySelector('.js-modal-container-inner-middle');

                const modalContainerOuterStyles = window.getComputedStyle(modalContainerOuter);
                const modalContainerInnerStyles = window.getComputedStyle(modalContainerInner);
                const modalContainerTopStyles = window.getComputedStyle(modalContainerTop);
                const modalContainerBottomStyles = window.getComputedStyle(modalContainerBottom);
        
                // buffer zone between the inner and the outer container
                const topBufferZone = 20;
                let calculatedMaxHeight = 0;

                calculatedMaxHeight = 
                    parseFloat(modalContainerOuterStyles['height']) - 
                    (
                        (topBufferZone * 2) + 
                        (parseFloat(modalContainerInnerStyles['padding-top']) * 2) +
                        parseFloat(modalContainerTopStyles['height']) +
                        parseFloat(modalContainerTopStyles['padding-bottom']) +
                        parseFloat(modalContainerTopStyles['border-bottom-width']) +
                        parseFloat(modalContainerBottomStyles['height']) +
                        parseFloat(modalContainerBottomStyles['padding-top']) +
                        parseFloat(modalContainerBottomStyles['border-top-width'])
                    );

                modalContainerMiddle.style.maxHeight = (calculatedMaxHeight / 10) + 'rem';
            },
            calculateChangeOwnerMiddleSectionMaxHeight: function () {
                if (!this.showChangeOwnerForm) return;
               
                this.calculateMaxHeightFunction(this.$el.querySelector('.change-owner__container--modal'));
            },
        },
        components: { FormField, Ajax },
    };
</script>
